import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { ContentTypesHeaderQuery } from '@confluence/content-types-utils/entry-points/ContentTypesHeaderQuery.graphql.ts';
import { expVal } from '@confluence/feature-experiments';

export function preloadContentTypesHeader(contentId: string, useObjectHeader: boolean) {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: ContentTypesHeaderQuery,
		variables: {
			contentId,
			useObjectHeader,
		},
	}).then((result) => {
		if (expVal('confluence_frontend_ssr_space_not_found', 'isEnabled', false)) {
			const contentIsRestrictedBySpacePermissions = result?.errors?.find(
				(e) => e?.path?.[0] === 'content' && e?.message?.includes('Space is restricted'),
			);

			window['__SPACE_RESTRICTED_ERROR__'] = contentIsRestrictedBySpacePermissions
				? contentId
				: null;
		}

		return result;
	});
}
